import Vue from 'vue';
import RadialProgressBar from 'vue-radial-progress';

Vue.use(RadialProgressBar);
